import MysteryWord from '../../reusable-components/mystery-word/mystery-word';
import './searching-screen.scss';

interface  SearchingScreenProps {
  userWord: string;
  mysteryWord: string;
  errorMessage?: string;
}

/**
 * The screen displayed while searching for videos, showing the user's input and the mystery word question marks.
 * @param {string} userWord - The user's word input.
 * @param {string} mysteryWord - The mystery word.
 * @param {string} errorMessage - (optional) if provided a non empty string, this error message will display instead of the searching message.
 * */
const SearchingScreen: React.FC<SearchingScreenProps> = ({userWord, mysteryWord, errorMessage}) => {

  return (
    <div className="searching-screen">
      {!errorMessage && 
        <div className="searching-box">
          <span className="searching-label">Searching:</span>
          <span className="searching-words">{userWord} <MysteryWord mysteryWord={mysteryWord}/></span>
        </div>
      }
      {errorMessage &&
        <div className="error-box">{errorMessage}</div>
      }
    </div>
  )
}

export default SearchingScreen;